export const logo = require("../assets/image_logo.png");
export const sideImg = require("../assets/otp_side_img.png");